export default __webpack_public_path__ + "static/media/MiniaturaAttribution.5c18212b.jpg";